import { createFileRoute } from '@tanstack/react-router'

import AddressCreatePage from '@/views/customer/pages/address.create.page'

export const Route = createFileRoute('/_layout/customer/address/create')({
  component: AddressCreatePage,
})
